import { render, staticRenderFns } from "./playClassInstall.vue?vue&type=template&id=76fd8738&scoped=true&"
import script from "./playClassInstall.vue?vue&type=script&lang=ts&"
export * from "./playClassInstall.vue?vue&type=script&lang=ts&"
import style0 from "./playClassInstall.vue?vue&type=style&index=0&id=76fd8738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd8738",
  null
  
)

export default component.exports